module.exports = __webpack_public_path__ + "static/img/login-logo.acd6d5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/login-logo.png
// module id = XYSM
// module chunks = 1